module.exports = __webpack_public_path__ + "static/img/pkg.69737fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/pkg.png
// module id = SEE2
// module chunks = 53